import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { CheckCircle, Users, MessageCircle } from "lucide-react";
import { useCountry } from "@/contexts/country";

const UnderstandingCards = () => {
  const { countryName } = useCountry();

  if (!countryName) {
    return null;
  }

  const cards = [
    {
      icon: <CheckCircle className="h-8 w-8 text-nation-purple" />,
      title: "Verified Citizens",
      description: `Every participant is a verified citizen of ${countryName}, ensuring authentic representation.`,
    },
    {
      icon: <Users className="h-8 w-8 text-nation-teal" />,
      title: "Real Representation",
      description: `Our platform reflects the true voice of ${countryName}'s diverse population.`,
    },
    {
      icon: <MessageCircle className="h-8 w-8 text-nation-blue" />,
      title: "Ongoing Dialogue",
      description: `Beyond elections, we maintain continuous civic engagement in ${countryName}.`,
    },
  ];

  return (
    <section className="py-16 px-4 bg-white dark:bg-gray-900/50">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold mb-4 text-nation-blue dark:text-blue-300">
            Understanding {countryName}
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            NationCard™ provides authentic insights into what matters most to
            the people of {countryName}.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {cards.map((card, index) => (
            <Card
              key={index}
              className="text-center hover:shadow-lg transition-shadow duration-300"
            >
              <CardHeader className="pb-2">
                <div className="w-16 h-16 bg-gray-50 dark:bg-gray-800 rounded-full flex items-center justify-center mx-auto mb-4">
                  {card.icon}
                </div>
                <h3 className="font-semibold text-xl">{card.title}</h3>
              </CardHeader>
              <CardContent>
                <p className="text-muted-foreground leading-relaxed">
                  {card.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default UnderstandingCards;
